import {
  AfterViewChecked,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  QueryList,
  ViewChildren
} from '@angular/core';
import { Router } from '@angular/router';

import { DataMaterialsService } from '@components/materials/data-materials.service';
import { ProjectRouteKey } from '@custom-types/project';
import { GlobalDataService } from '@providers/global-data/global-data.service';
import { ModelsToolsService } from '@providers/models-tools/models-tools.service';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.less']
})
export class MenuComponent implements OnInit, OnDestroy, AfterViewChecked {
  routes: any;
  currentProject: any;
  @ViewChildren('item') items: QueryList<ElementRef<HTMLDivElement>>;
  @Output()   closeMenu = new EventEmitter();
  @Input('currentCategory') public currentCategory: any;
  private routeObs$;

  constructor(
    private router: Router,
    private globalDataService: GlobalDataService,
    public dataMaterialsService: DataMaterialsService,
    private modelsToolsService: ModelsToolsService
  ) {
    this.routes = [];
  }

  ngOnInit() {
    this.globalDataService.getCurrentProject().subscribe(async (project: any) => {
      if (!project || this.currentProject) {
        return;
      }

      this.currentProject = project;

      this.dataMaterialsService.currentProject = project;

      await this.dataMaterialsService.computeProjectMaterialsData();

      this.dataMaterialsService.refreshData = false;

      this.routes = [
        {
          badge: 0,
          href: `/projects/${project.id}/dashboard`,
          key: 'dashboard',
          label: 'Accueil',
          active: this.router.isActive(`/projects/${project.id}/dashboard`, false)
        },
        {
          label: 'Documents',
          badge: 0,
          href: `/projects/${project.id}/files`,
          key: 'files',
          active: this.router.isActive(`/projects/${project.id}/files`, false)
        },
        {
          label: 'Devis',
          badge: 0,
          href: `/projects/${project.id}/quotations`,
          key: 'quotations',
          active: this.router.isActive(`/projects/${project.id}/quotations`, false)
        },
        {
          label: 'Matériaux',
          badge: 0,
          href: `/projects/${project.id}/materials/orders`,
          key: 'materials',
          active: this.router.isActive(`/projects/${project.id}/materials/orders`, false),
          show: this.dataMaterialsService.hasProjectMaterials()
        },
        {
          label: 'Planning',
          badge: 0,
          href: `/projects/${project.id}/schedule`,
          key: 'schedule',
          active: this.router.isActive(`/projects/${project.id}/schedule`, false)
        },
        {
          label: 'Financier',
          badge: 0,
          href: `/projects/${project.id}/balance`,
          key: 'balance',
          active: this.router.isActive(`/projects/${project.id}/balance`, false)
        },
        {
          label: 'Chantier',
          badge: 0,
          href: `/projects/${project.id}/chantier`,
          key: 'chantier',
          active: this.router.isActive(`/projects/${project.id}/chantier`, false)
        },
        {
          label: 'Catalogue',
          badge: 0,
          href: `/projects/${project.id}/showrooms`,
          key: 'showroom',
          active: this.router.isActive(`/projects/${project.id}/showrooms`, false)
        }
      ];

      this.filterNavBar();

      if (!this.routeObs$) {
        this.routeObs$ = this.router.events.subscribe((val: any) => {
          this.routes = [...this.routes].map((route) => {
            const newRoute = { ...route };

            newRoute.active = this.router.isActive(route.href, false);

            return newRoute;
          });
        });
      }
    });
  }

  ngOnDestroy() {
    if (this.routeObs$) {
      this.routeObs$.unsubscribe();
    }
  }

  filterNavBar() {
    if (this.currentProject && this.globalDataService.steps) {
      const currentStep = this.currentProject._related.steps[0];

      if (currentStep) {
        if (!this.modelsToolsService.isStepValid(currentStep.id)) {
          this.routes = [];
        } else if (this.globalDataService.checkStepIsBefore(currentStep.slug, 'handoff_meeting')) {
          this.routes = this.routes.filter(r => r.key !== 'chantier' && r.key !== 'balance');
        }
      }
    }

    this.routes = this.routes.filter(r => r.show === undefined || r.show === true);
  }

  menuClicked(route) {
    this.routes = this.routes.map((r) => {
      r.active = (r.key === route.key);

      return r;
    });

    this.closeMenu.emit(route.label);
  }

  ngAfterViewChecked(): void {
    this.selectWithPath(window.location.pathname);
  }

  selectWithPath(path) {
    let selectedKey: ProjectRouteKey;

    this.routes.forEach((route) => {
      if (path.includes(route.href)) {
        selectedKey = route.key;
      }
    });

    this.items.toArray().map((item) => {
      this.unselect(item.nativeElement);

      const key = item.nativeElement.getAttribute('data-key');

      if (key === selectedKey) {
        this.select(item.nativeElement);
      }
    });
  }

  unselect(target): void {
    if (target.classList.contains('selected')) {
      target.classList.remove('selected');
    }
  }

  select(target): void {
    if (!target.classList.contains('selected')) {
      target.classList.add('selected');
    }
  }

  getIcon(route) {
    let icon = [];
    switch (route.key) {
      case 'dashboard':
        icon = ['fal', 'home'];
        break;
      case 'files':
        icon = ['fal', 'folders'];
        break;
      case 'quotations':
        icon = ['fal', 'file-invoice-dollar'];
        break;
      case 'balance':
        icon = ['fal', 'file-invoice-dollar'];
        break;
      case 'materials':
        icon = ['fal', 'tools'];
        break;
      case 'schedule':
        icon = ['fal', 'calendar-check'];
        break;
      case 'pictures':
        icon = ['fal', 'images'];
        break;
      case 'chantier':
        icon = ['fal', 'tasks'];
        break;
      case 'showroom':
        icon = ['fal', 'lamp-floor'];
        break;
      default:
        break;
    }
    return icon;
  }
}
